import { TFunction } from "i18next";
import * as Yup from "yup";

export const getProfessionalModalMotiveDeleteSchema = (t: TFunction) => {

    return Yup.object().shape({
        motiveDelete: Yup.string()
            .required(t("common:form.requiredFieldForm"))
            .typeError(t("common:form.invalidDateForm")),
    });
};


export const getProfessionaFormSchema = (t: TFunction) => {

    
    return Yup.object().shape({
        nameAndSurname: Yup.string()
            .required(t("common:form.requiredFieldForm"))
    });
    
};